import React from 'react';

import { AlmeThemeMode } from '../../models/AlmeTheme';

import { Switch, FormControlLabel } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { AlmeConfig } from '../../models/AlmeConfig';

const useStyles = makeStyles(() =>
    createStyles({
        almeThemeModeToggleContainer: {
            marginLeft: '0',
        },
    }),
);

interface AlmeThemeModeToggleProps {
    setThemeMode: (themeMode: AlmeThemeMode) => void;
    themeMode: AlmeThemeMode;
    almeConfig: AlmeConfig;
}

const AlmeThemeModeToggle: React.FC<AlmeThemeModeToggleProps> = (props: AlmeThemeModeToggleProps) => {
    const classes = useStyles();

    const isDarkChecked = props.themeMode === 'dark' ? true : false;

    const handleChange = () => (event: React.ChangeEvent<HTMLInputElement>): void => {
        const themeMode: AlmeThemeMode = event.target.checked ? 'dark' : 'light';
        props.setThemeMode(themeMode);
        updateTestPageTheme(themeMode);
    };

    const toggleLabel = props.almeConfig.themeModeToggle.label || '';

    return (
        <FormControlLabel className={classes.almeThemeModeToggleContainer}
            control={
                <Switch id='alme-theme-toggle' checked={isDarkChecked}
                    onChange={handleChange()} value="darkChecked" size="small" />
            }
            label={toggleLabel} />
    );
};

export default AlmeThemeModeToggle;

function updateTestPageTheme(themeMode: AlmeThemeMode): void {
    const textColor = themeMode === 'dark' ? 'white' : 'black';
    const backgroundColor = themeMode === 'dark' ? 'black' : 'white';
    document.body.style.backgroundColor = backgroundColor;
    document.body.style.color = textColor;
}